<template>
  <div class='bottom-entrance-wrap'>
    <div class='entrance-item fx-row fx-m-between fx-c-center' v-for="(item, index) in options" :key='index'>
      <div class='imgWrap'><img :src="item.iconUrl" alt='' :class="item.className" /></div>
      <div class="a-text-15 a-lightblack fx-1">{{item.txt}}</div>
      <div class='a-gray a-text-15' v-if='item.num'>{{item.num}}</div>
      <div class='a-arrow'></div>
    </div>
    
  </div>
</template>

<script>

export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  computed: {
    options() {
      let num = 0;
      if (this.list && this.list.length) {
        this.list.map(item => {
          if ( item.title == '我的积分' ) {
            num = item.describe;
          }
        })
      }
      return [
        {iconUrl: 'https://cdn.133.cn/gtgj/vipcard/signIn.png', txt: '签到红包', className: 'icon-signIn'},
        {iconUrl: 'https://cdn.133.cn/gtgj/vipcard/integral.png', txt: '我的积分', className: 'icon-integral', num}
      ];
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.bottom-entrance-wrap {
  background: #ffffff;
  @mixin imgStyle($width, $height) {
    width: $width * $px;
    height: $height * $px;
    display: block;
  }
  .icon-signIn {
    @include imgStyle(24, 24);
  }
  .icon-integral {
    @include imgStyle(25, 24);
  }
  .a-arrow {
    border-color: #B2BDCB;
    width: 7 * $px;
    height: 7 * $px;
    margin-left: 10 * $px;
  }
  .entrance-item {
    height: 49 * $px;
    padding: 0 14 * $px;
    border-top: 0.5 * $px solid #ebebeb;
    &:first-child {
      border-top: 0 none;
    }
    .imgWrap {
      width: 38 * $px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/components/home-bottom-entrance.vue